export default function urlCheck(url) {
  const pat = /^https?:\/\/|^\/\//i;
  let result = false;

  if (pat.test(url)) {
    result = true;
  }

  return result;
}
